module.exports = __webpack_public_path__ + "static/media/Floor003-02.8f375482.png";